import { Pipe, PipeTransform } from '@angular/core';
import { Address } from '@morningstar/shared/models';

@Pipe({
  name: 'address'
})
export class AddressPipe implements PipeTransform {

  transform(value: Address, ...args: any[]): any {
    let address = value.address1;

    if (value.address2 != null) {
      address += ` ${value.address2}`;
    }

    if (value.city != null) {
      address += `, ${value.city}`;
    }

    if (value.state != null) {
      address += `, ${value.state}`;
    }

    if (value.postal != null) {
      address += ` ${value.postal}`;
    }

    return address;
  }
}
